const ROUNDING_FACTOR = 100;
const MONTHS_IN_YEAR = 12;

const toFiniteNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const toSafeNumber = (value, fallback = 0) => {
  const numericValue = toFiniteNumber(value);
  return numericValue === null ? fallback : numericValue;
};

export const round2 = (value) =>
  Math.round((Number(value) + Number.EPSILON) * ROUNDING_FACTOR) / ROUNDING_FACTOR;

export const computeMonthlyFixedCharges = (annualAmount) => {
  const annualValue = toFiniteNumber(annualAmount);
  if (annualValue === null) {
    return 0;
  }

  return Math.round(annualValue / MONTHS_IN_YEAR);
};

export const toMonthlyAmount = (amount, mode = "MONTHLY") => {
  const numericAmount = toFiniteNumber(amount);
  if (numericAmount === null) {
    return 0;
  }

  const normalizedMode = String(mode || "MONTHLY").toUpperCase();
  if (normalizedMode === "ANNUAL") {
    return round2(numericAmount / 12);
  }

  return numericAmount;
};

export const toAnnualAmount = (amount, mode = "MONTHLY") => {
  const numericAmount = toFiniteNumber(amount);
  if (numericAmount === null) {
    return 0;
  }

  const normalizedMode = String(mode || "MONTHLY").toUpperCase();
  if (normalizedMode === "MONTHLY") {
    return round2(numericAmount * 12);
  }

  return numericAmount;
};

export const alignMonthlyFixedCostCategories = (items = [], monthlyTotal) => {
  if (!Array.isArray(items) || items.length === 0) {
    return [];
  }

  const normalizedItems = items.map((item) => ({
    ...item,
    amount_monthly_total: toSafeNumber(item?.amount_monthly_total),
  }));
  const categoriesTotal = normalizedItems.reduce(
    (sum, item) => sum + item.amount_monthly_total,
    0,
  );
  if (categoriesTotal <= 0) {
    return normalizedItems;
  }

  const targetMonthlyTotal = Math.max(0, toSafeNumber(monthlyTotal));
  if (Math.abs(categoriesTotal - targetMonthlyTotal) < 0.01) {
    return normalizedItems;
  }

  const ratio = targetMonthlyTotal / categoriesTotal;
  const scaledItems = normalizedItems.map((item) => ({
    ...item,
    amount_monthly_total: round2(item.amount_monthly_total * ratio),
  }));
  const scaledTotal = scaledItems.reduce((sum, item) => sum + item.amount_monthly_total, 0);
  const roundingGap = round2(targetMonthlyTotal - scaledTotal);

  if (scaledItems.length > 0 && roundingGap !== 0) {
    scaledItems[0] = {
      ...scaledItems[0],
      amount_monthly_total: round2(
        Math.max(0, scaledItems[0].amount_monthly_total + roundingGap),
      ),
    };
  }

  return scaledItems;
};

export const formatMonth = (monthKey) => {
  if (!monthKey) {
    return "—";
  }

  const parsedDate = new Date(`${monthKey}-01T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return monthKey;
  }

  return new Intl.DateTimeFormat("fr-FR", {
    month: "long",
    year: "numeric",
  }).format(parsedDate);
};
